import { FaIcon } from '@ifixit/ui/components/icon';
import { setLastLoginMethod } from './LogIn/lastLoginMethod';
import { RecentlyUsedBadge } from './RecentlyUsedBadge';

export function SSOButton({
   text,
   href,
   recentlyUsed,
}: {
   text: string;
   href: string;
   recentlyUsed?: boolean;
}) {
   return (
      <a
         href={href}
         className="w-full z-1 cursor-pointer"
         id="ssoLogin"
         onClick={() => setLastLoginMethod('sso')}
      >
         <button
            type="button"
            className="button-outline button-lg w-full px-0 font-medium min-h-10"
         >
            <FaIcon name="right-to-bracket" className="size-5 text-brand-500" />
            <span className="ml-2">{text}</span>
         </button>
         {recentlyUsed && <RecentlyUsedBadge />}
      </a>
   );
}
